<template>
  <div id="app">
    <v-card>
      <v-img max-height="85" src="@/assets/img/background.png">
        <v-app-bar flat class="mt-2" color="rgba(0, 0, 0, 0)">
          <v-btn color="white" @click="goBack()" icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <p class="text-white-title mt-4">Master Role</p>
        </v-app-bar>
      </v-img>
    </v-card>
    <v-card class="mx-3 mt-5 px-2 w-100">
      <v-row>
        <v-col
          cols="12"
          lg="4"
          md="4"
          sm="4"
          xs="12"
          class="pb-0"
          style="border: 3px solid #f4f5f6"
        >
          <div>
            <p class="text-bold mt-3">{{ label }} Role</p>
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <v-form @submit.prevent="handleSubmit(submitForm)">
                <v-row>
                  <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="py-0">
                    <p class="app-title-small text-sm ma-0">
                      Role Name
                    </p>
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Role Name"
                      rules="required"
                    >
                      <v-text-field
                        v-model="role_name"
                        :error-messages="errors"
                        single-line
                        dense
                        outlined
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-2">
                    <v-btn
                      type="submit"
                      color="#f58721"
                      class="text-center ma-1"
                      width="100%"
                      dark
                      :loading="loading"
                      small
                      v-if="editCondition === false"
                    >
                      <span class="text-capitalize">Add Role</span>
                    </v-btn>
                    <v-btn
                      type="submit"
                      color="#f58721"
                      class="text-center ma-1"
                      width="100%"
                      dark
                      :loading="loading"
                      small
                      v-if="editCondition === true"
                    >
                      <span class="text-capitalize">Update</span>
                    </v-btn>
                    <v-btn
                      color="#ef4723"
                      @click.prevent="closeSuccessNavigate"
                      class="text-center ma-1"
                      width="100%"
                      dark
                      small
                    >
                      <span class="text-capitalize">Cancel</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </div>
        </v-col>
        <v-col cols="12" lg="8" md="8" sm="8" xs="12" class="pb-0">
          <div>
            <v-card-title>
              List Role
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="res_role"
              :items-per-page="5"
              :search="search"
              class="elevation-1"
            >
              <template v-slot:item.menu="{ item }">
                <v-btn x-small @click="goTo(item.id)" color="#f58721"
                  ><span class="text-white">Detail Role</span></v-btn
                >
              </template>
              <template v-slot:item.delete="{ item }">
                <v-btn text @click="showModalDelete(item.id)" color="#c60000"
                  >Delete</v-btn
                >
              </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <!-- dialog success -->
    <v-dialog v-model="dialog" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="green" size="100px">mdi-checkbox-marked-circle</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >{{ label }} Role <br />Success</v-card-title
        >
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="closeSuccessNavigate"
            color="green"
            :loading="loading"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- modal Delete -->
    <v-dialog v-model="deleteDialog" persistent max-width="450">
      <v-card class="pa-2">
        <v-card-title class="text-blood pl-2 pt-1 pr-0 pb-3"
          >Delete role
          <v-spacer></v-spacer>
          <v-icon
            class="float-right"
            color="grey"
            @click.prevent="deleteDialog = false"
            >mdi-close</v-icon
          >
        </v-card-title>
        <div class="text-center pa-3">
          <v-avatar size="142px" class="mb-4">
            <img src="@/assets/img/delete.png" />
          </v-avatar>
          <p class="text-blood">Apakah anda ingin menghapus role?</p>
        </div>
        <v-card-actions class="py-0 px-10">
          <v-spacer></v-spacer>
          <v-btn
            width="100%"
            rounded
            color="#F5F5F5"
            @click="deleteDialog = false"
            block
            dark
          >
            <span class="text-capitalize text-blue">Close</span>
          </v-btn>
        </v-card-actions>
        <v-card-actions class="py-0 px-10 mt-3 justify-center text-center">
          <v-btn
            :loading="loadingDel"
            @click="submitDelete"
            text
            block
            color="#F32626"
            >Yas! Delete role</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog failed -->
    <v-dialog v-model="dialog2" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="#F32626" size="100px">mdi-alert-circle-outline</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >{{ label }} Role <br />Failed</v-card-title
        >
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="dialog2 = false"
            color="green"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("system");
export default {
  name: "role",
  components: {},
  data() {
    return {
      dialog: false,
      dialog2: false,
      loading: false,
      role_name: null,
      search: null,
      editCondition: false,
      create_new: null,
      loadingDel: false,
      nama_role: null,
      deleteDialog: false,
      temp_id: null,
      label: "Insert",
      headers: [
        { text: "Role Name", value: "name" },
        { text: "", value: "menu" },
        { text: "", value: "delete" }
      ]
    };
  },
  watch: {},
  mounted() {
    this.$store.dispatch("system/getRole");
  },
  computed: {
    ...mapState(["res_role"])
  },
  methods: {
    goBack() {
      this.$router.push("/dashboard");
    },
    closeSuccessNavigate() {
      setTimeout(() => {
        this.$router.go(0);
      }, 200);
    },
    goTo(val) {
      this.$router.push("role/" + val);
    },
    showModalDelete(val) {
      this.deleteDialog = true;
      this.$store.commit("system/SET_IDROLE", val);
    },
    submitDelete() {
      // button effect
      this.label = "Delete";
      this.loadingDel = true;
      this.$store
        .dispatch("system/deleteRole")
        .then(response => {
          const res = response.data;
          if (res.data) {
            this.deleteDialog = false;
            this.dialog = true;
            this.loadingDel = false;
          } else {
            this.deleteDialog = false;
            this.dialog2 = true;
            this.loadingDel = false;
          }
        })
        .catch(error => {
          const message = error.response.data.message;
          this.errorMessage = message;
          this.deleteDialog = false;
          this.dialog2 = true;
          this.loadingDel = false;
        });
    },
    goToEdit(val) {
      this.role_name = val.name;
      this.temp_id = val.id;
      this.editCondition = true;
      this.$vuetify.goTo(0);
    },
    submitForm() {
      this.loading = true;
      let actionitem = null;
      if (this.editCondition === false) {
        actionitem = "system/createRole";
        this.label = "Insert";
      } else {
        this.$store.commit("system/SET_IDROLE", this.temp_id);
        actionitem = "system/updateRole";
        this.label = "Update";
      }
      this.loading = true;
      this.formInput = {
        name: this.role_name
      };
      this.$store.commit("system/SET_TEMPROLE", this.formInput);
      this.$store
        .dispatch(actionitem)
        .then(response => {
          const res = response.data;
          if (res.data) {
            this.dialog = true;
            this.loading = false;
          } else {
            this.dialog2 = true;
            this.loading = false;
          }
        })
        .catch(error => {
          const message = error.response.status.message;
          this.errorMessage = message;
          this.dialog2 = true;
          this.loading = false;
        });
    }
  }
};
</script>
